/**
 * List View Types
 * 
 * Type definitions for the list view visualization mode.
 */

import { DisplayNode } from '../recipe_renderer/types.js';

/**
 * Represents a node in the list view tree structure
 */
export interface ListNode {
  /** The underlying display node */
  displayNode: DisplayNode;
  /** Depth level in the tree (0 = root) */
  level: number;
  /** Whether this node is expanded (children visible) */
  isExpanded: boolean;
  /** Whether this node is selected (for bulk operations) */
  isSelected: boolean;
  /** Child nodes in the tree */
  children: ListNode[];
}

/**
 * State for the list view
 */
export interface ListViewState {
  /** Set of node IDs that are expanded */
  expandedNodeIds: Set<string>;
  /** Set of node IDs that are selected */
  selectedNodeIds: Set<string>;
}

/**
 * Configuration options for list view
 */
export interface ListViewConfig {
  /** Indentation per level in pixels */
  indentPerLevel: number;
  /** Whether to show edit buttons (when in edit mode) */
  showEditButtons: boolean;
}

/**
 * Default configuration
 */
export const DEFAULT_LIST_VIEW_CONFIG: ListViewConfig = {
  indentPerLevel: 16,
  showEditButtons: false,
};
